// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"ef23fcb6","510":"3b301228"}[chunkId] + ".chunk.js";
};